import classNames from 'classnames';
import React from 'react';
import EfImgVideo from '../ef-img-video';
import './index.scss';

export interface EfCardsBItemProps {
    /**
     * 图片链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * 展示位置(水平方向)
     */
    position?: 'center' | 'left50';
    /**
     * 展示位置(竖直方向)
     */
    vertical?: 'default' | 'descTop';
    /**
     * 主标题
     */
    title?: React.ReactNode;
    /**
     * 描述
     */
    desc?: React.ReactNode;
    /**
     * 主标题2
     */
    title2?: React.ReactNode;
    /**
     * 背景色 class
     */
    itemMsgBgClass?: string;
    /**
     * 图片中固定位置的 icon or text
     */
    fixedElement?: any;
}
interface EfCardsBProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    items: EfCardsBItemProps[];
}

/**
 * 维护:谢保林
 *
 * 卡片列表
 */
const EfCardsB: React.FC<EfCardsBProps> = ({ items, className }) => {
    const prefixCls = `ef-cards-b`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            {items?.map((item: EfCardsBItemProps, index: number) => {
                return (
                    <div
                        key={index}
                        className={`${prefixCls}-item ${prefixCls}-item-position-${item.position || 'center'} ${prefixCls}-item-vertical-${
                            item.vertical || 'default'
                        } ${prefixCls}-item-${index + 1}`}
                    >
                        <div className={`${prefixCls}-item-img`}>
                            <EfImgVideo
                                isVideo={item.isVideo}
                                pc={item.pc}
                                h5={item.h5}
                                poster={item.poster}
                                posterH5={item.posterH5}
                                autoPlay={true}
                                loop={true}
                            />
                        </div>
                        <div className={`${prefixCls}-item-msg ${item?.itemMsgBgClass}`}>
                            <div className={`${prefixCls}-item-msg-in`}>
                                {item.title && <div className={`${prefixCls}-item-title`}>{item.title}</div>}
                                {item.desc && <div className={`${prefixCls}-item-desc`}>{item.desc}</div>}
                                {item.title2 && <div className={`${prefixCls}-item-title2`}>{item.title2}</div>}
                            </div>
                            {!!item?.fixedElement && <div className={`${prefixCls}-item-fixed-element`}>{item.fixedElement}</div>}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default EfCardsB;
